
export default {
  productData: {
    serialNumber: 'DA-MME-008',
    name: 'Massivholzdecke mit Estrich l Aufbau 8',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolldämmplatte MW<br>(<i>s‘</i> ≤ 10 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 30',
          value: 'm-30'
        },
        {
          type: 'fill',
          title: { de: 'Ungebundener Splitt' },
          output: '≥ 65',
          value: 'us-65'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Brettsperrholzdecke' },
          output: 120,
          value: 'bsh-120'
        }
      ],
      sum: {
        output: '275', value: 275
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '47 (-3; 7)',
        value: 47
      },
      soundReductionIndex: { // Rw
        output: '75 (-2; -7)',
        value: 75
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,44',
        value: 0.44
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '304 [kg/m²]'
      }
    }
  },
  image: 'da-mme-008.svg',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-8-DA-MME-008-Rev01.pdf'
}
